import { createReducer, on } from '@ngrx/store';
import {StateStatus} from "../../../shared/models/state-status.models";
import {
  getAllUsers,
  getAllUsersFailure,
  getAllUsersSuccess, getTenantsListOfUserRoles, getTenantsListOfUserRolesFailure, getTenantsListOfUserRolesSuccess,
  updateUsersCustomerId,
  updateUsersCustomerIdFailure, updateUsersCustomerIdSuccess
} from "./graph-user.action";
import {Role} from "../../../shared/models/role.model";


export interface GraphUserState {
  users: any[];
  tenantRoles: Role[];
  error: string | null;
  status: StateStatus;
}

export const initialState: GraphUserState = {
  users: [],
  tenantRoles: [],
  error: null,
  status: 'pending' as StateStatus,
};

export const graphUserReducer = createReducer(
  initialState,
  on(getAllUsers, (state) => ({ ...state, status: 'loading' as StateStatus })),
  on(getAllUsersSuccess, (state, { users }) => ({
    ...state,
    users: users,
    error: null,
    status: 'loadSuccess' as StateStatus,
  })),
  on(getAllUsersFailure, (state, { error }) => ({
    ...state,
    error: error,
    status: 'error' as StateStatus,
  })),

  on(getTenantsListOfUserRoles, (state) => ({ ...state, status: 'loading' as StateStatus })),
  on(getTenantsListOfUserRolesSuccess, (state, { tenantRoles }) => ({
    ...state,
    tenantRoles: tenantRoles,
    error: null,
    status: 'loadSuccess' as StateStatus,
  })),
  on(getTenantsListOfUserRolesFailure, (state, { error }) => ({
    ...state,
    error: error,
    status: 'error' as StateStatus,
  })),

  on(updateUsersCustomerId, (state) => ({
    ...state,
    status: 'modifying' as StateStatus,
  })),
  on(updateUsersCustomerIdFailure, (state, { error }) => ({
    ...state,
    error: error,
    status: 'error' as StateStatus,
  })),
  on(updateUsersCustomerIdSuccess, (state, { users }) => ({
    ...state,
    users: users,
    error: null,
    status: 'modifySuccess' as StateStatus,
  })),
);
